import React, { useEffect, useState, useRef } from "react";
import { useSearchParams } from "react-router-dom";
import {
  Box,
  Button,
  Grid,
  Stack,
  TextField,
  Typography,
  useMediaQuery,
  Fade,
} from "@mui/material";
import BubbleComponent from "./BubbleComponent";
import { ConversationComponent } from "./ConversationComponent";
import SendIcon from "@mui/icons-material/Send";
import { dbr } from "../firebase/config";
import { onValue, ref, set, push, query, limitToLast } from "firebase/database";
import theme from "../ColorsConfig";

export default function ViewChatComponent(props) {
  //const register = useSelector((state) => state.auth);
  // const reference = useRef(null);
  const isSmUp = useMediaQuery(theme.breakpoints.up("sm"));
  const [searchParams] = useSearchParams();
  const isAdmin = props.isAdmin;
  const [messages, setMessages] = useState([]);
  const [message, setMessage] = useState(String());
  const [user, setUser] = useState(String());
  const [waiting, setWating] = useState(Number());

  const external = useRef(null);
  useEffect(() => {
    // if (isAdmin == null) {
    //   console.log("AQuiu");
    //   let type = searchParams.get("type");
    //   console.log(type);
    //   setIsAdmin(type === "admin");
    // }
    const q = query(ref(dbr, "messages"), limitToLast(isSmUp ? 150 : 50));
    return onValue(q, (snapshot) => {
      const data = snapshot.val();
      if (snapshot.exists()) {
        setMessages(data);
        if (external) {
          external.current.onClick();
        }
      }
    });
  }, [user, isAdmin, searchParams, isSmUp]);

  useEffect(() => {
    let timer = null;
    if (waiting > Number()) {
      timer = setInterval(() => {
        setWating(waiting - 1);
      }, 1000);
    }
    return () => clearInterval(timer);
  }, [waiting]);

  const handleTextChange = (e) => {
    const value = e.target.value;
    setMessage(value);
  };

  const Push = (mss = null) => {
    const postListRef = ref(dbr, "messages");
    const newPostRef = push(postListRef);
    set(newPostRef, {
      message: mss ? mss : message,
      user: isAdmin ? `${user}_admin` : user,
    });
    setMessage(String());
    if (external) {
      external.current.onClick();
    }
    if (!isAdmin) {
      setWating(6);
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      handleSend();
    }
  };

  function uuidv4() {
    return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
      (
        c ^
        (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
      ).toString(16)
    );
  }

  const handleSend = () => {
    if (message.trim() === "") return;
    if (user === String()) {
      setUser(`${message}_${uuidv4()}`);
      setMessage(String());
    } else {
      Push();
    }
  };

  const emojis = ["😀", "😎", "🤩", "🥳", "🤯", "✋"];

  const renerInputText = () => {
    if (waiting > Number()) {
      return `Próximo mensaje en ${waiting}`;
    } else {
      return user !== String() ? "Escribe tu mensaje" : "ALVARO CRUZ";
    }
  };

  const renderEmojis = () => {
    return emojis.map((emoji, index) => {
      return (
        <Typography
          key={index}
          sx={{ fontSize: 33 }}
          onClick={() => {
            if (user !== String()) {
              if (waiting === Number()) {
                Push(emoji);
              }
            }
          }}
        >
          {emoji}
        </Typography>
      );
    });
  };

  const renderToolBar = () => {
    return (
      <Grid
        container
        bottom="0"
        spacing={1}
        sx={{
          mt: 3,
          mb: 3,
        }}
      >
        {/* <Grid item xs={12}>
          <Stack spacing={2} direction={"row"}>
            {renderEmojis()}
          </Stack>
        </Grid> */}
        <Grid item xs={9}>
          <TextField
            fullWidth
            disabled={waiting > Number()}
            placeholder={renerInputText()}
            value={message}
            onChange={handleTextChange}
            onKeyDown={handleKeyDown}
            helperText={user ? String() : "ESCRIBE TU NOMBRE"}
          ></TextField>
        </Grid>
        <Grid item xs={3}>
          <Button
            variant="outlined"
            onClick={handleSend}
            sx={{ bgcolor: "white", color: "#000", borderColor: "#000" }}
          >
            {user !== String() ? "Enviar" : "Unirme"}
          </Button>
        </Grid>
      </Grid>
    );
  };

  return (
    // CONTAINER
    <Box

    // sx={{ maxHeight: { xs: "10vh", sm: "10vh", md: "88vh" } }}
    >
      <ConversationComponent
        ref={external}
        messages={Object.keys(messages).map((message) => {
          return {
            ...messages[message],
            identifier: message,
          };
        })}
        user={user}
      />
      <Box component="footer">{renderToolBar()}</Box>
    </Box>
  );
}
